import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

/**
 * Unified page header: eyebrow + title + subtitle on the left, action buttons on
 * the right. Wraps gracefully on small screens; optional back navigation.
 */
const PageHeader = ({ title, subtitle, eyebrow, backTo, actions, sx }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 2,
        mb: { xs: 2.5, md: 3.5 },
        ...sx,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ flex: '1 1 auto', minWidth: 0 }}>
        {backTo !== undefined && (
          <IconButton
            aria-label="Go back"
            onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
            sx={{
              border: (theme) => `1px solid ${theme.custom.cardBorder}`,
              backgroundColor: 'background.paper',
              flexShrink: 0,
            }}
          >
            <ArrowBackRoundedIcon fontSize="small" />
          </IconButton>
        )}
        <Box sx={{ minWidth: 0 }}>
          {eyebrow && (
            <Typography variant="overline" sx={{ color: 'primary.main', display: 'block', lineHeight: 1.4 }}>
              {eyebrow}
            </Typography>
          )}
          <Typography variant="h3" component="h1" noWrap sx={{ fontSize: { xs: '1.45rem', md: '1.75rem' } }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {actions && (
        <Stack
          direction="row"
          spacing={1.25}
          alignItems="center"
          sx={{ flexShrink: 0, width: { xs: '100%', sm: 'auto' }, '& > *': { flex: { xs: 1, sm: '0 0 auto' } } }}
        >
          {actions}
        </Stack>
      )}
    </Box>
  );
};

export default PageHeader;
